import axiosInstance from './axiosConfig';

type Props = { slug: string };

const switchClientOrganization = ({ slug }: Props) =>
    axiosInstance.post(`/wt/api/v1/company/${slug}/switch/`);

export default switchClientOrganization;
